<template>
    <relatorio-page :titulo=" 'Relatório de Receitas e Despesas dos Projetos' " :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="false">
        
        <v-row>
            <v-col cols="12" md="12" class="font-weight-bold">
                Período dos projetos: {{new Date(filtro.dataInicial).ddmmyyyy()}} até {{new Date(filtro.dataFinal).ddmmyyyy()}}
            </v-col>
        </v-row>        

        <hr class="solid">

        <v-row>
            <v-col cols="12" md="12" class="pa-0">
                
                <v-simple-table dense>
                    <template v-slot: default>
                        <thead style="background-color: #4A70A8">
                            <tr class="fonte">
                                <th class="text-left" style="font-size: 100% ; color: white">Cód.</th>
                                <th class="text-center" style="font-size: 100% ; color: white">Projetos</th>
                                <th class="text-center" style="font-size: 100% ; color: white">Receitas</th>
                                <th class="text-center" style="font-size: 100% ; color: white">Despesas</th>
                                <th class="text-center" style="font-size: 100% ; color: white">Saldo</th>
                            </tr>
                        </thead>
                        <tbody v-for="(itens, index) in item.itens" :key="index">
                            <tr class="fonte" :style=" index == item.itens.length - 1 ? 'background-color: #4A70A8' : index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                <td class="text-left" :style=" index == item.itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{itens.idProjeto}}</td>
                                <td class="text-left" :style=" index == item.itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{itens.nome}}</td>
                                <td class="text-right" :style=" index == item.itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{itens.receita ? itens.receita.toMoeda(true) : '-' }}</td>
                                <td class="text-right" :style=" index == item.itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{itens.despesa ? itens.despesa.toMoeda(true) : '-'}}</td>
                                <td class="text-right" :style=" index == item.itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{itens.saldo.toMoeda(true)}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

                <v-row>
                    <v-spacer/>
                    <v-col cols="4">
                        <span class="text-right font-weight-bold" style="font-size: 100%">{{ item.nome }}: {{item.total? item.total.toMoeda(true) : ''}}</span>                        
                    </v-col>
                </v-row>
                           
            </v-col>
        </v-row>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import { ProjetoService } from '../../../core/services/projetos';
export default {
    
    data: () => ({
        item:{
            required: true
        },
        filtro:{
            required: true
        },
        overlay: false
    }),
    props:{

    },
    mounted(){
        this.filtro = this.$route.query;
        this.Carregar();
    },
    methods:{
        Carregar(){
            const projetoService = new ProjetoService();
            this.overlay = true
            projetoService.GetReceitaDespesa(this.filtro).then(
                res=>{
                    this.item = res.data;
                    this.item.itens[this.item.itens.length - 1].idProjeto = null;
                },
                err=>{
                    this.$swal('Aviso', err.response.data, 'error')
                }
            ).finally(() =>{
                this.overlay = false;
            })
        }
    }   

}
</script>

<style>

.fonte{
  font-size: 90%;
}

</style>
